export const documentProps = {
  title: 'Internal Knowledge Assistant — One AI for All Your Company Knowledge',
  description:
    'Stop interrupting your day to answer the same staff questions. We build one AI assistant that knows everything your company knows — and answers instantly, 24/7. HIPAA-aware.',
};
